module.exports = __webpack_public_path__ + "img/bg-3.8fc3a176.png";